// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yOzQ","placeholdersHeader":"styles_placeholdersHeader__345rG","editorStyle":"styles_editorStyle__3X9r-","placeholdersBox":"styles_placeholdersBox__KXCTJ"};